var _defs, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserProfileV1 = function SvgUserProfileV1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Calque_1",
    "data-name": "Calque 1",
    viewBox: "0 0 486 487.71",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#81b3e1;}.cls-1{opacity:0.4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "userV1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 243,
    cy: 243,
    r: 243
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.09,178.62a91,91,0,1,1-90.95,91,91.06,91.06,0,0,1,90.95-91Z",
    transform: "translate(-113 -87)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,574.71A202,202,0,0,1,224.55,526.2,38.78,38.78,0,0,1,211,496.7c0-50.93,41.26-91.7,92.18-91.7H409.09a91.59,91.59,0,0,1,92,91.7,38.76,38.76,0,0,1-13.56,29.5A202.07,202.07,0,0,1,356,574.71Z",
    transform: "translate(-113 -87)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserProfileV1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-profile-v1.647ba021d8863a237a4d19c2d26175cb.svg";